// extracted by mini-css-extract-plugin
export default {"container":"BottomCTA_container__nNEiT","solid":"BottomCTA_solid__7tO+0","inner":"BottomCTA_inner__ir7Pg"};